// Ouverture et fermeture d'un <dialog> modal. jsdom n'implemente pas toujours
// showModal/close : on retombe alors sur l'attribut open.
export function showModal(dialog: HTMLDialogElement): void {
  if (typeof dialog.showModal === 'function') {
    dialog.showModal();
  } else {
    dialog.setAttribute('open', '');
  }
}

export function closeDialog(dialog: HTMLDialogElement): void {
  if (typeof dialog.close === 'function') {
    dialog.close();
  } else {
    dialog.removeAttribute('open');
  }
}
